// Vue does not publicly export escapeHtml; use its installed shared utility.
// eslint-disable-next-line vue/prefer-import-from-vue
import { escapeHtml } from '@vue/shared';

export default function queryParamRouteGuard(to) {
    const searchParams = new URLSearchParams(document.location.search)
    for (let [key, value] of searchParams.entries()) {
      to.query[key] = escapeHtml(value);
    }
}
